import React from 'react';

import PostCommentForm from 'components/comment/PostCommentForm';
import CommentList from 'components/comment/CommentList';
import Link from 'components/misc/Link';
import { generateArticleLink } from 'utils/generateShareLink';

import { ArticleWithLink } from 'entity/blog/blogTypes';
import ArticleEngagement from './ArticleEngagement';
import Byline from '../Byline';

interface OwnProps {
  article: ArticleWithLink;
}

// This will be use on /community page.
const ArticleItem = (props: OwnProps) => {
  const { article } = props;
  const {
    id,
    articleId,
    commentsCount,
    slug,
    imageUrl,
    excerpt,
    author,
    publishDate,
    title,
    categories,
    link,
    parentCommentsCount,
  } = article;
  const mainCategory = categories[0];

  return (
    <div className="rounded-lg h-fit w-full p-4 bg-white relative">
      <div className="flex flex-col gap-4">
        <div className="flex flex-row-reverse lg:flex-row items-center lg:items-start gap-4">
          <Link {...link}>
            <a>
              <img
                className="rounded  max-w-[100px] lg:max-w-[289px] max-h-[69px] lg:max-h-[152px]"
                src={imageUrl}
                alt="article"
                data-testid="article-item"
              />
            </a>
          </Link>
          <div className="flex flex-col gap-4">
            <Link as={mainCategory.link.as} href={mainCategory.link.href}>
              <a className="text-blue-500 text-xs font-bold">
                {mainCategory.name.toUpperCase()}
              </a>
            </Link>
            <Link {...link}>
              <a className="text-base font-bold hover:text-blue-500">{title}</a>
            </Link>
            <p className="desktop-only">{excerpt}</p>
            <Byline author={author} publishDate={publishDate} />
          </div>
        </div>
        <ArticleEngagement
          articleSlug={slug}
          articleId={articleId}
          commentsCount={commentsCount}
        />
        <div className="horizontal-divider" />
        <PostCommentForm commentableType="Article" commentableId={id} />
        <CommentList
          totalCommentCount={parentCommentsCount}
          commentableId={id}
          commentableType="Article"
          childCommentableType="ArticleComment"
          commentShareLink={generateArticleLink(slug)}
        />
      </div>
    </div>
  );
};

export default ArticleItem;
